import React from "react";
// import Login from "./login.component";
import Login from "./loginNew.component"

const Account = ({type, account, success,logged_in,user}) => {

    return(
        <>
         {type === 1 ? <Login account={account} success={success} /> : ''}
        </>
    )
}

export default Account;